import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login");
      return;
    }
    api
      .post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { state: { user: data } });
      })
      .catch(() => navigate("/login"));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <Loader2 className="animate-spin text-[#CC5500]" size={32} />
    </div>
  );
}
